import React, { useState, useCallback } from "react";
import { FaTimes, FaCopy, FaCheck } from "react-icons/fa";

const UrlModal = ({ isOpen, onClose, url, message }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Fallback copy failed:", err);
      }
      document.body.removeChild(textArea);
    }
  }, [url]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content url-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>עסקה הושלמה בהצלחה!</h3>
          <button className="modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          {message && (
            <div className="success-message">
              <p>{message}</p>
            </div>
          )}

          <div className="url-section">
            <label>קישור לצפייה בפרטי הציוד:</label>
            <div className="url-input-container">
              <input
                type="text"
                value={url}
                readOnly
                className="url-input"
                onClick={(e) => e.target.select()}
              />
              <button
                className={`copy-btn ${copied ? "copied" : ""}`}
                onClick={handleCopy}
                title={copied ? "הועתק!" : "העתק"}
              >
                {copied ? <FaCheck /> : <FaCopy />}
                <span>{copied ? "הועתק!" : "העתק"}</span>
              </button>
            </div>
            <p className="url-hint">
              העתק את הקישור ושלח לחייל לצפייה בפרטי הציוד המוחתם
            </p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="close-btn" onClick={onClose}>
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default UrlModal;
